import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import React from "react";
import axios from "axios";
import { Link } from "@mui/material";
import { useEffect, useState } from "react";

const ContainerTop = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  minHeight: 900,
}));

const PTitle = styled("div")(() => ({
  backgroundColor: "rgba(245, 255, 250, 1)",
  fontSize: 48,
  fontWeight: 700,
  color: "rgba(49, 55, 61, 1)",
  paddingTop: "32px",
  paddingBottom: "12px",
  width: "100%",
  minHeight: "140px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));

const PTitle2 = styled("div")(() => ({
  width: "100%",
  backgroundColor: "rgba(245, 255, 250, 1)",
  fontSize: 36,
  fontWeight: 400,
  color: "rgba(49, 55, 61, 1)",
  padding: "32px",
  textAlign: 'center'
}));

const PTable = styled("div")(() => ({
  width: '80vw',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderTop: "1px solid rgba(217, 217, 217, 1)",
  borderLeft: "12px solid rgba(211, 242, 226, 1)",
  borderRight: "12px solid rgba(211, 242, 226, 1)",
  marginTop: '32px'
}));

const PInfo1 = styled("span")(({ theme }) => ({
  fontSize: 36,
  fontWeight: 400,
  color: "rgba(115, 118, 122, 1) !important",
  padding: "16px 32px 16px 8px",
  width: '35%',
  textAlign: 'right'
}));

const PInfo = styled(Link)(({ theme }) => ({
  fontSize: 36,
  fontWeight: 700,
  color: "rgba(37, 157, 95, 1) !important",
  width: "60%",
  padding: "16px 32px 16px 8px",
  backgroundColor: "rgba(247, 247, 247, 1)",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
}));

function Top() {
  const [list, setList] = useState([]);
  const [loadError, setLoadError] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    const data = {
      pageNum: 1,
      pageSize: 9999999,
      queryText: ""
    };

    let url = "https://admin.toposfy.com/admin/sysDrive/getDriveList";

    axios
      .post(url, data)
      .then(function (response) {
        const { status, data } = response;
        if (status === 200 && data.code === 200) {
          setList(data.data);
          setLoadError(false);
        } else {
          setLoadError(true);
        }
      })
      .catch(function () {
        setLoadError(true);
      });
  }, []);
  return (
    <ContainerTop id="xzTop">
      <PTitle>{t("xz.x4")}</PTitle>
      <PTitle2>{t("xz.x5")}</PTitle2>
      {loadError ? <PTitle2>{t("xz.loadFail")}</PTitle2> : null}
      <PTable>
      {list.map((v) => {
        return (
          <div
            style={{
              display: "flex",
              "justify-content": "center",
              width: "80vw",
              "word-wrap": "break-word",
              "word-break": "break-all",
              overflow: "hidden",
              borderBottom: "1px solid rgba(217, 217, 217, 1)",
            }}
          >
            <PInfo1>{v.name}：</PInfo1>
            <PInfo
              href={v.downloadUrl}
              underline="none"
              sx={{ color: "inherit" }}
            >
              {v.downloadUrl}
            </PInfo>
          </div>
        );
      })}
      </PTable>
    </ContainerTop>
  );
}

function Web() {
  return (
    <>
      <Top />
    </>
  );
}
export default Web;
